/**
 * BOGO Bright Landing Page – Selection & Cart Logic
 * Lets customers pick a premium bike + a free bike and checkout directly.
 * Supports variant dropdowns (color/size) per card, like the WMTM page.
 */
(function () {
  'use strict';

  var selectedBuy = null;   // { variantId, name, price, availability }
  var selectedFree = null;  // { variantId, name, price, availability }

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    // Buy cards — select button or click card area (not dropdown)
    document.querySelectorAll('.bb-buy-card[data-variant-id]').forEach(function (card) {
      var btn = card.querySelector('.bb-select-buy');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          selectBuyCard(card);
        });
      }
      card.addEventListener('click', function (e) {
        if (e.target.closest('.bb-variant-selector') || e.target.closest('.bb-select-btn')) return;
        selectBuyCard(card);
      });
    });

    // Free cards
    document.querySelectorAll('.bb-free-card[data-variant-id]').forEach(function (card) {
      var btn = card.querySelector('.bb-select-free');
      if (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          selectFreeCard(card);
        });
      }
      card.addEventListener('click', function (e) {
        if (e.target.closest('.bb-variant-selector') || e.target.closest('.bb-select-btn')) return;
        selectFreeCard(card);
      });
    });

    // Variant dropdowns — update card data when variant changes
    document.querySelectorAll('.bb-variant-dropdown').forEach(function (select) {
      select.addEventListener('change', function () {
        handleVariantChange(select);
      });
    });

    // CTA buttons
    document.querySelectorAll('.bb-cta-button[data-action="checkout"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        handleCheckout(btn);
      });
    });

    updateUI();
    startScarcityTimer();
  }

  /* ---- Variant dropdown change ---- */
  function handleVariantChange(select) {
    var card = select.closest('.bb-buy-card, .bb-free-card');
    if (!card) return;

    var selectedOption = select.options[select.selectedIndex];
    var variantId = selectedOption.value;
    var price = parseInt(selectedOption.dataset.price, 10) || 0;
    var variantImage = selectedOption.dataset.image;

    // Update card data attributes
    card.dataset.variantId = variantId;
    card.dataset.productPrice = Math.round(price / 100);

    // Update displayed price
    var priceEl = card.querySelector('.bb-price');
    if (priceEl) {
      priceEl.textContent = '$' + (price / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    // Update free-value display for free cards
    var freeValueEl = card.querySelector('.bb-free-value');
    if (freeValueEl) {
      freeValueEl.textContent = '$' + (price / 100).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }) + ' Value';
    }

    // Update shipping ETA
    var availability = selectedOption.dataset.availability;
    if (availability) {
      var etaEl = card.querySelector('.bb-eta-text');
      if (etaEl) etaEl.textContent = availability;
    }

    // Swap image if variant has one
    if (variantImage) {
      var imgEl = card.querySelector('.bb-variant-image');
      if (imgEl) {
        imgEl.style.opacity = '0.5';
        imgEl.src = variantImage;
        imgEl.onload = function () { imgEl.style.opacity = '1'; };
      }
    }

    // If this card is already selected, update the selection state
    if (card.classList.contains('selected')) {
      var avail = (selectedOption.dataset.availability || '').trim();
      if (card.classList.contains('bb-buy-card')) {
        selectedBuy = {
          variantId: variantId,
          name: card.dataset.productName,
          price: Math.round(price / 100),
          availability: avail
        };
      } else {
        selectedFree = {
          variantId: variantId,
          name: card.dataset.productName,
          price: Math.round(price / 100),
          availability: avail
        };
      }
      updateUI();
    }
  }

  /* ---- Get availability from card ---- */
  function getCardAvailability(card) {
    var dropdown = card.querySelector('.bb-variant-dropdown');
    if (dropdown) {
      var opt = dropdown.options[dropdown.selectedIndex];
      return (opt && opt.dataset.availability) || '';
    }
    var etaEl = card.querySelector('.bb-shipping-eta');
    return etaEl ? (etaEl.dataset.defaultEta || '') : '';
  }

  /* ---- Buy card selection ---- */
  function selectBuyCard(card) {
    document.querySelectorAll('.bb-buy-card').forEach(function (c) {
      c.classList.remove('selected');
      var b = c.querySelector('.bb-select-buy');
      if (b) b.textContent = 'Select This Bike';
    });
    card.classList.add('selected');
    var selBtn = card.querySelector('.bb-select-buy');
    if (selBtn) selBtn.textContent = 'Selected';

    var dropdown = card.querySelector('.bb-variant-dropdown');
    var variantId = dropdown ? dropdown.value : card.dataset.variantId;

    selectedBuy = {
      variantId: variantId,
      name: card.dataset.productName,
      price: parseInt(card.dataset.productPrice, 10) || 0,
      availability: getCardAvailability(card)
    };

    updateUI();
  }

  /* ---- Free card selection ---- */
  function selectFreeCard(card) {
    document.querySelectorAll('.bb-free-card').forEach(function (c) {
      c.classList.remove('selected');
      var b = c.querySelector('.bb-select-free');
      if (b) b.textContent = 'Select This Bike';
    });
    card.classList.add('selected');
    var selBtn = card.querySelector('.bb-select-free');
    if (selBtn) selBtn.textContent = 'Selected';

    var dropdown = card.querySelector('.bb-variant-dropdown');
    var variantId = dropdown ? dropdown.value : card.dataset.variantId;

    selectedFree = {
      variantId: variantId,
      name: card.dataset.productName,
      price: parseInt(card.dataset.productPrice, 10) || 0,
      availability: getCardAvailability(card)
    };

    updateUI();
  }

  /* ---- Update price summary & CTA state ---- */
  function updateUI() {
    var ready = selectedBuy && selectedFree;

    // Update hint text
    var hints = document.querySelectorAll('.bb-selection-hint');
    hints.forEach(function (el) {
      if (!selectedBuy) {
        el.textContent = 'Select a premium bike above to get started';
      } else if (!selectedFree) {
        el.textContent = 'Now pick your FREE bike below';
      } else {
        el.textContent = selectedBuy.name + ' + ' + selectedFree.name + ' \u2014 Ready to order!';
      }
    });

    // Update dynamic price summary if elements exist
    var summaryEl = document.getElementById('bb-dynamic-summary');
    if (summaryEl && selectedBuy && selectedFree) {
      var originalTotal = selectedBuy.price + selectedFree.price;
      var youPay = selectedBuy.price;
      var savings = selectedFree.price;

      var origEl = document.getElementById('bb-orig-price');
      var payEl = document.getElementById('bb-you-pay');
      var saveEl = document.getElementById('bb-save-amount');

      if (origEl) origEl.textContent = '$' + originalTotal.toLocaleString();
      if (payEl) payEl.textContent = '$' + youPay.toLocaleString();
      if (saveEl) saveEl.textContent = 'You Save $' + savings.toLocaleString() + ' \u2014 FREE Bike!';
    }

    // CTA buttons
    document.querySelectorAll('.bb-cta-button[data-action="checkout"]').forEach(function (btn) {
      if (ready) {
        btn.classList.remove('disabled');
        btn.removeAttribute('disabled');
      } else {
        btn.classList.add('disabled');
        btn.setAttribute('disabled', 'disabled');
      }
    });
  }

  /* ---- Checkout ---- */
  function handleCheckout(btn) {
    if (!selectedBuy || !selectedFree) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.innerHTML = '<span class="bb-spinner"></span> Adding to cart\u2026';

    var buyId = parseInt(selectedBuy.variantId, 10);
    var freeId = parseInt(selectedFree.variantId, 10);
    var buyAvail = selectedBuy.availability || '';
    var freeAvail = selectedFree.availability || '';

    console.log('BOGO Bright: adding buy variant', buyId, 'avail:', buyAvail, 'free variant', freeId, 'avail:', freeAvail);

    // Add buy bike first, then free bike
    addToCart(buyId, buyAvail)
      .then(function () {
        return addToCart(freeId, freeAvail);
      })
      .then(function () {
        btn.innerHTML = '<span class="bb-spinner"></span> Redirecting\u2026';
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('BOGO Bright cart error:', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  }

  function addToCart(variantId, availability) {
    var payload = {
      id: variantId,
      quantity: 1
    };
    if (availability) {
      payload.properties = {
        'Availability': availability
      };
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          console.error('Shopify cart error:', data);
          throw new Error(data.description || data.message || 'Cart error');
        }
        return data;
      });
    });
  }

  /* ---- Scarcity counter ---- */
  function startScarcityTimer() {
    var countEls = document.querySelectorAll('.bb-count');
    if (!countEls.length) return;

    var bundles = parseInt(countEls[0].textContent, 10) || 23;
    setInterval(function () {
      if (bundles > 3 && Math.random() > 0.85) {
        bundles--;
        countEls.forEach(function (el) { el.textContent = bundles; });
      }
    }, 25000);
  }
})();
